// MIRRORS: panel/components/photoFrame/photoFrame.tsx — identical copy; edit both, or delete this line on both to declare a deliberate split.
import styles from './photoFrame.module.scss';

export interface PhotoFrameProps {
  src: string;
  alt?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

/**
 * Shows a photo whole instead of cropping it, inside a box whose size never
 * changes.
 *
 * Sellers shoot on phones, so most uploads are portrait while every frame in
 * the app is landscape — `object-fit: cover` would scale those to fill and cut
 * roughly 40% away. The photo uses `contain`, and the leftover space is filled
 * by the same image blurred and scaled behind it, so nothing is cropped and no
 * empty bars show.
 *
 * The backdrop is the identical URL, so the browser fetches once and the second
 * element is served from cache.
 */
export function PhotoFrame({ src, alt = '', className, loading }: PhotoFrameProps) {
  return (
    <div className={`${styles.frame} ${className ?? ''}`}>
      <img className={styles.backdrop} src={src} alt="" aria-hidden loading={loading} />
      <img className={styles.photo} src={src} alt={alt} loading={loading} />
    </div>
  );
}
